module.exports = __webpack_public_path__ + "img/p4.521eaaf2.png";